<template>
    <div class="containerLoader" v-if="visible">
        <div class="loader"></div>
    </div>
</template>

<script>
export default {
    props:{
        visible: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../Css/AgroIdeas.scss";
.containerLoader {
    display: flex;
    align-items: center;
    justify-content: center;
    margin:10px;
}
.loader {
    border: 8px solid #f3f3f3;
    border-radius: 50%;
    border-top: 8px solid $AgroIdeas;
    width: 50px;
    height: 50px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
